import React from 'react';

interface IMainProps {
    children: React.ReactNode;
}

export const Main: React.FC<IMainProps> = ({ children }) => {
    return <main className="main">{children}</main>;
};
